/*
 * maxLengthNumberInput
 * Since not all browers accept input type=number as legit
 */

const maxLengthNumberInput = () => {
  const element = $('input[type=number][maxlength]');

  if (element.length === 0) {
    return;
  }

  element.on('input', (event) => {
    const currentElement = $(event.currentTarget);
    const valueLength = Number(currentElement.val().length);
    const maxLength = Number(currentElement.attr('maxlength'));

    if (valueLength > maxLength) {
      currentElement.val(currentElement.val().slice(0, maxLength));
    }
  });
};

export default maxLengthNumberInput;
